import React from 'react';
import {
  OvTableData,
  OvTableRowData,
} from '../../../components/UI/molecules/OvTable';
import Colours from '../../../design-system/colours';
import i18n from '../../../i18n/config';
import { PdfReport } from '../../model/dto/pdf-report';
import DateUtils from './date-utils';
import styled from 'styled-components';

export class PdfReportUtils {
  static mapPdfReportsToTableData(pdfReportList: PdfReport[]): OvTableData {
    const tableData: OvTableData = [];

    pdfReportList.forEach((pdfReport, index) => {
      const nestedRows: OvTableRowData[] = [
        {
          label: 'pdfReports.pdfUrl',
          value: pdfReport?.pdf_url ? i18n.t('common.actions.viewDoc') : '',
          translateLabel: true,
          linkUrl: pdfReport?.pdf_url,
        },
      ];

      const isCycleReport = pdfReport.pdf_report_type === 'cycle-report';
      const reportTypeLabel = isCycleReport
        ? i18n.t('pdfReports.cycleReport', 'Cycle report')
        : i18n.t('pdfReports.customInterval', 'Custom interval report');

      tableData.push({
        rowId: pdfReport.id,
        label: DateUtils.formatDate(pdfReport.created_at, 'DD/MM/yyyy'),
        value: pdfReport.title ?? '',
        secondaryValue: (
          <SecondaryValueContainer>
            <ReportTypeChip $isCycleReport={isCycleReport}>
              {reportTypeLabel}
            </ReportTypeChip>
            <span>
              {`${i18n.t('common.createdBy')}: ${
                pdfReport?.created_by?.first_name ?? ''
              } ${pdfReport?.created_by?.last_name ?? ''}`}
            </span>
          </SecondaryValueContainer>
        ),
        style: {
          backgroundColor: Colours.OV_LIGHT_GRAY,
        },
        showNestedRows: index === 0,
        nestedRows,
      });
    });

    return tableData;
  }
}

const SecondaryValueContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const ReportTypeChip = styled.span<{ $isCycleReport: boolean }>`
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.15rem 0.6rem;
  border-radius: 12px;
  min-width: 10rem;
  text-align: center;
  display: inline-block;
  background-color: ${({ $isCycleReport }) =>
    $isCycleReport ? Colours.OV_LIGHT_BLUE : Colours.LIGHT_GRAY_BLUE};
  color: ${({ $isCycleReport }) =>
    $isCycleReport ? Colours.OV_BASE : Colours.OV_CHARCOAL};
  white-space: nowrap;
`;
